import React from 'react';
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import DisplayLongDescriptionAndVariantMFRName from 'src/component/custom/DisplayLongDescriptionAndVariantMFRName';
import { useProductStore } from 'src/hooks/product';
import System from 'src/helper/system';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';

const CartPriceMisMatchBackOrder = (props) => {
    const { data, SetStatus } = props
    const { misMatchData = [], inventoryData = [] } = data;
    const [{ productList }, { }, { },] = useProductStore();
    const [{ }, { get_inventory_by_id }, { },] = useProductInventoryPriceStore();

    const getCartProductInventoryLeadTimeByERPPartNumber = (ERPPartNumber) => {
        const inventory = get_inventory_by_id(ERPPartNumber)
        return inventory.plifz ? inventory.plifz : ""
    };

    const onHide = () => {
        SetStatus(false)
    };

    const updateQty = async () => {
        let d = [];
        // Note: Should First take inventory, because having backorder Qty, Do not update the sequence
        if (inventoryData.length) {
            inventoryData.map((v) => {
                d.push({
                    cartDetailId: v.cartDetailId,
                    quantity: v.adjustedQuantity,
                    backOrderedQuantity: v.adjustedQuantity, // check this senario which is having inventory Qty
                    erpMfrPartNumber: v.ERPMFRPartNumber,
                    itemNumber: v.ItemNumber,
                    manufacturerPartNumber: v.ManufacturerPartNumber,
                    manufacturerCode: v.manufacturerCode,
                    manufacturerName: v.manufacturerName,
                    assetURL: v.assetURL,
                    currency: v.currency,
                    cpn: v.cpn,
                    erpManufacturerName: v.erpManufacturerName,
                    erpManufacturerCode: v.erpManufacturerCode,
                });
            });
        }

        misMatchData.map((v) => {
            if (!v.invMsg) {
                d.push({
                    cartDetailId: v.cartDetailId,
                    quantity: v.adjustedQuantity,
                    ERPMFRPartNumber: v.ERPMFRPartNumber,
                    itemNumber: v.ItemNumber,
                    manufacturerPartNumber: v.ManufacturerPartNumber,
                    manufacturerCode: v.manufacturerCode,
                    manufacturerName: v.manufacturerName,
                    assetURL: v.assetURL,
                    currency: v.currency,
                    cpn: v.cpn,
                    erpManufacturerName: v.erpManufacturerName,
                    erpManufacturerCode: v.erpManufacturerCode,
                });
            }
        });

        // if (d.length) {
        //    // await Update_Cart_Items_Server(d, true, true)
        // }
        // onHide(false);
    }

    return (
        <div className="avnet-modal modal-680">
            <div className="avnet-modal-inner">
                <button type="button" className="close" data-dismiss="modal"
                    onClick={() => { onHide() }}>×
                </button>
                <div className="modal-header justify-content-center mt-0">
                    <h3 className="pcn-modal-heading">Price Mismatch
                        {inventoryData.length ? "and Inventory Alert" : ""}</h3>
                </div>
                <div className="m-4 mt-0 mb-0">
                    <div className="justify-content-start">
                        There is a mismatch between selected Quantity and the available price tier. <br />
                        We currently do not have sufficient inventory for the following item(s).<br />
                        Please contact your local sales officer for a lower quantity pricing.<br /> <br />

                            Confirm the adjusted quantity and backorder by clicking the <b>Yes</b> button below.
                            <br />
                            <b>Note:</b> you can always remove item(s) from cart after confirming adjustments
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="inventory-table price-mismatch-table">
                            <table className="table table-outline rounded-0">
                                <thead>
                                    <tr className="bg-light">
                                        <th colSpan={4} className='text-center'>Price Mismatch</th>
                                    </tr>
                                    <tr>
                                        <th className="border-0 text-none font-12">Product(s)</th>
                                        <th className="border-0 text-none font-12">Requested Qty</th>
                                        <th className="border-0 text-none font-12">Adjusted Qty</th>
                                        <th className="border-0 text-none font-12">Unit Price</th>
                                    </tr>
                                </thead>
                                <tbody className="border-top-0">
                                    {misMatchData?.length && misMatchData.map((v) => (
                                        <tr key={v.ItemNumber}>
                                            <td className="align-middle">
                                                <div className="inventory-product-info">
                                                    <div className="inventory-product-name">
                                                        <NavigateToProductDetail data={{ SEOManufacturerName: productList[v.ItemNumber].SEOManufacturerName, SEOERPMFRPartNumber: productList[v.ItemNumber].SEOERPMFRPartNumber, ItemNumber: productList[v.ItemNumber].ItemNumber, ERPPartNumber: productList[v.ItemNumber].ERPPartNumber }}>
                                                            <b className='text-black'>{productList[v.ItemNumber].ERPMFRPartNumber}</b>
                                                        </NavigateToProductDetail>
                                                    </div>
                                                    <div className="inventory-product-by">
                                                        <DisplayLongDescriptionAndVariantMFRName
                                                            currentProduct={{ ManufacturerName: productList[v.ItemNumber]?.ManufacturerName, ShortDescription: productList[v.ItemNumber]?.ShortDescription }} />
                                                    </div>
                                                    {v.invMsg && <span className="mandatory">{v.invMsg}</span>}
                                                </div>
                                            </td>
                                            <td className="align-top">
                                                <span>{v.quantity}</span>
                                            </td>
                                            <td className="align-top">
                                                <span>{v.adjustedQuantity}</span>
                                            </td>
                                            <td className="align-top">
                                                <span>{System.getFormatNumber({ amount: Number(v.adjustedPrice) })}</span>
                                            </td>
                                        </tr>
                                    ))}
                                    {inventoryData.length ?
                                        <>

                                            <tr className="bg-light">
                                                <th colSpan={4} className='text-center'>INVENTORY ALERT</th>
                                            </tr>
                                            <tr>
                                                <th className="border-0 text-none font-12">Product(s)</th>
                                                <th className="border-0 text-none font-12">Requested Qty</th>
                                                <th className="border-0 text-none font-12">Adjusted Qty</th>
                                                <th className="border-0 text-none font-12">BackOrder Qty </th>
                                            </tr>
                                            {inventoryData.map((v) => (
                                                <tr key={v.ItemNumber}>
                                                    <td className="align-middle">
                                                        <div className="inventory-product-info">
                                                            <div className="inventory-product-name">
                                                                <NavigateToProductDetail data={{ SEOManufacturerName: productList[v.ItemNumber].SEOManufacturerName, SEOERPMFRPartNumber: productList[v.ItemNumber].SEOERPMFRPartNumber, ItemNumber: productList[v.ItemNumber].ItemNumber, ERPPartNumber: productList[v.ItemNumber].ERPPartNumber }}>
                                                                    <b className='text-black'>{productList[v.ItemNumber].ERPMFRPartNumber}</b>
                                                                </NavigateToProductDetail>
                                                            </div>
                                                            <div className="inventory-product-by">
                                                                <DisplayLongDescriptionAndVariantMFRName
                                                                    currentProduct={{ ManufacturerName: productList[v.ItemNumber]?.ManufacturerName, ShortDescription: productList[v.ItemNumber]?.ShortDescription }} />
                                                            </div>
                                                            <div className="inventory-product-stock"><b>In
                                                                Stock: {v.stock}</b>
                                                            </div>
                                                            <div className="inventory-product-lead">Lead Time From
                                                                Supplier: {getCartProductInventoryLeadTimeByERPPartNumber(v.ERPPartNumber)}
                                                            </div>
                                                            {v.misMatchMsg && <span className="mandatory">{v.misMatchMsg}</span>}
                                                        </div>
                                                    </td>
                                                    <td className="align-top">
                                                        <span>{v.quantity}</span>
                                                    </td>
                                                    <td className="align-top">
                                                        <span>{v.adjustedQuantity}</span>
                                                    </td>
                                                    <td className="align-top">
                                                        <span>{v.adjustedQuantity}</span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </> : null
                                    }
                                </tbody>
                            </table>
                            <div className='text-end'><p>Item Subtotal: (EUR) <strong>€577,60</strong> </p> </div>
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145"
                                data-bs-toggle="modal" data-bs-target="#InventoryModal"
                                onClick={() => { onHide(false) }}>
                                No
                            </button>
                            <button type="button" className="bs5 btn btn-primary btn-sm w145"
                                onClick={async () => { await updateQty() }}
                                data-bs-toggle="modal" data-bs-target="#InventoryModal">
                                Yes
                            </button>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default CartPriceMisMatchBackOrder;